import * as effects from 'redux-saga/effects';
import { IAdvertisementTelevisionActionTypes } from './Types';
import {
  getAdvertisementTelevision,
  getAdvertisementTelevisionFailure,
  getAdvertisementTelevisionSuccess,
} from './Actions';
import { Backend } from '../../Backend/Backend';

function* handleGetAdvertisementTelevision(
  action: ReturnType<typeof getAdvertisementTelevision>
) {
  const backend = Backend.getInstance();
  try {
    const result = yield effects.apply(backend, backend.getTvAd, [
      action.payload,
    ]);
    if (result) {
      // todo implement verification result is AdResult
      yield effects.put(getAdvertisementTelevisionSuccess(result));
    } else {
      throw new Error('response is not a result');
    }
  } catch (err) {
    if (err instanceof Error) {
      yield effects.put(getAdvertisementTelevisionFailure(err.message));
    } else if (typeof err === 'string') {
      yield effects.put(getAdvertisementTelevisionFailure(err));
    } else {
      yield effects.put(
        getAdvertisementTelevisionFailure('Unknown error occurred')
      );
      console.log(err);
    }
  }
}

function* watchAdvertisementTelevision() {
  yield effects.takeEvery(
    IAdvertisementTelevisionActionTypes.GET_AD_TV,
    handleGetAdvertisementTelevision
  );
}

export function* AdvertisementTelevisionSaga() {
  yield effects.all([effects.fork(watchAdvertisementTelevision)]);
}
